<template>
  <div class="case-preview-wrap">
    <div class="content">
    <xl-scrollbar>
        <div class="content-center">
            <div class="card">
                <div class="head">
                    <div class="title">
                        <img :src="$getCdnUrl(info.activeCommodity?.image)" alt="">
                        <span class="name">{{ info.activeCommodity?.productConfigName}}</span>
                        <span class="soon" v-if="info.isUrgent">{{ $t('design.case.soon') || '加急'}}</span>
                    </div>
                    <div class="price">
                        <span>{{ $t('design.order.totalPrice') }}</span>
                        <span>{{ formatPrice(afterTaxPrice) }} {{ info.activeCommodity?.currency }}</span>
                        <span v-if="totalPoints">/{{ $t('design.point.pointNum', { point: totalPoints }) }}</span>
                    </div>
                </div>
                <div class="hr"></div>
                <div class="detail">
                    <div class="item">
                        <div class="key">{{$t('design.orderDetail.caseName') || '案例名称'}}</div>
                        <div class="value">{{ info.orderName }}</div>
                    </div>
                    <div class="item">
                        <div class="key">{{$t('design.orderDetail.targetTooth') || '目标牙位'}}<span v-if="['perPiece', 'perHole'].includes(info.activeCommodity?.chargeUnit)">（{{info.dentalNotation}}）</span></div>
                        <div class="value">{{ info.toothsName }}</div>
                    </div>
                    <div class="item">
                        <div class="key">{{$t('design.case.designPrice') || '设计费用'}}/{{unitMap[info.activeCommodity?.chargeUnit]}}</div>
                        <div class="value">
                            <span>{{formatPrice(info.activeCommodity?.price)}} {{info.activeCommodity?.currency}}</span>
                            <span v-if="info.activeCommodity?.points">/{{ $t('design.point.pointNum', { point: info.activeCommodity?.points }) }}</span>
                            <span v-if="info.activeCommodity?.chargeUnit !== 'perCase'  && changeUnitLength>1">*{{changeUnitLength}}</span>
                        </div>
                    </div>
                    <div class="item" v-if="info.isUrgent">
                        <div class="key">{{$t('design.case.urgentPrice') || "加急费用"}}/{{unitMap[info.activeCommodity?.chargeUnit]}}</div>
                        <div class="value">{{formatPrice(info.activeCommodity?.urgentPrice)}} {{info.activeCommodity?.currency}}
                            <span v-if="info.activeCommodity?.urgentPoints">/{{ $t('design.point.pointNum', { point: info.activeCommodity?.urgentPoints }) }}</span>
                            <span v-if="info.activeCommodity?.chargeUnit !== 'perCase' && changeUnitLength>1">*{{changeUnitLength}}</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="key">
                            <xl-tooltip :content="$t('design.case.localTaxRate', { taxRate: info.taxRate })" placement="top">
                                <i class="iconfont icon-zhuyi" v-if="info.taxRate"></i>
                            </xl-tooltip>
                            <span>{{$t('design.case.taxPrice') || '增值税额'}}</span>
                        </div>
                        <div class="value">{{taxPrice ? `${formatPrice(taxPrice)} ${info.activeCommodity?.currency}` : '-' }}<span v-if="taxPrice && info.activeCommodity?.points">/-</span></div>
                    </div>
                    <div class="time">
                        <div class="key">{{$t('design.orderDetail.leadTime') || '预计交付周期'}}</div>
                        <div class="value"><span class="num">{{ time }}</span></div>
                    </div>
                </div>
            </div>
            <title-name v-if="info.requiredFiles?.length || info.optionalFiles?.length">{{$t('design.case.imageFiles') || "影像文件"}}</title-name>
            <div class="file-list">
                <div class="item block-item" :class="info.optionalFiles?.length ? 'item-first': ''" v-show="info.requiredFiles?.length">
                    <div class="title">{{$t('design.case.needFiles') || '必传文件'}}</div>
                    <div class="text" v-for="(item, index) in (info?.requiredFiles || [])" :key="index">
                        <span class="icon-file"></span>{{ item.imageName }}-{{ item.fileName }}
                    </div>
                </div>
                <div class="item block-item" v-show="info.optionalFiles?.length">
                    <div class="title">{{$t('design.case.optionalFiles') || '可传文件'}}</div>
                    <div class="text" v-for="(item, index) in (info?.optionalFiles || [])" :key="index">
                        <span class="icon-file"></span>{{ item.imageName }}-{{ item.fileName }}
                    </div>
                </div>
            </div>
            <!-- <div class="prefer-desc-wrap" v-show="hasPerenceInfo">
                <title-name class="desc-tlt">{{$t('design.orderDetail.designRequirement') || '设计需求'}}</title-name>
                <div class="perfer-image-tlt" @click="onShowImage">{{ $t('design.orderDetail.viewPreferenceImage') || '查看示意图'}}</div>
            </div> -->
            <design-requirement :infoList="preferDetail" :dentalNotation="info.dentalNotation" @viewImage="onShowImage" :selectProduct="info.productConfig"></design-requirement>
            <title-name class="desc-tlt" v-if="info.designContent">{{$t('design.orderDetail.otherRequirement') || '其他需求'}}</title-name>
            <div class="desc-list" v-if="info.designContent">
                <div class="item block-item">
                    <div class="text design-content" v-html="info.designContent"></div>
                </div>
            </div>
            <title-name class="desc-tlt design-description">{{ $t('design.case.designDescription') || '产品描述' }}</title-name>
            <div class="desc-list">
                <div class="item block-item">
                    <div class="text">{{ info.activeCommodity?.productRemark }}</div>
                </div>
            </div>
            <title-name class="desc-tlt">{{ $t('design.orderDetail.deliveryContent') || '交付内容' }}</title-name>
            <div class="desc-list">
                <div class="item block-item">
                    <div class="text">{{ info.activeCommodity?.productContent }}</div>
                </div>
            </div>
        </div>
    </xl-scrollbar>
    </div>
    <div class="footer">
        <xl-button type="primary" @click="onNext" :loading="loading">{{$t('design.case.confirmAndSend') || '确定并发送'}}</xl-button>
        <xl-button class="pre-btn" @click="onPre">{{$t('design.goBack') || '上一步'}}</xl-button>
    </div>
  </div>
  <template v-if="props.activeStep === 3">
    <design-image-dialog v-model:visible="visible" :currentType="currentType" :productName="info.productName" :infoList="preferDetail"></design-image-dialog>
  </template>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue';
import {
	XlButton,
	XlForm,
	XlFormItem,
	XlIcon,
	XlMessage,
	XlMessageBox,
    XlTooltip,
    XlScrollbar
} from '@shining3d/ui-components';
import { $lang } from '@shining3d/common-module/utils/index.js';
import BigNumber from "bignumber.js";
import TitleName from '../../components/titleName.vue';
import image from '../../assets/image/one.png';
import { $getCdnUrl, formatPrice, $timeUnit, toothInUpOrLowerJaw } from '../../utils/common';
import { timeMap } from './const';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import DesignRequirement from '../../components/designRequirement.vue';
const { $t } = useLang("@shining3d/xl-design-order");
import { unitMap, toothNameMap } from './const';
import Api from '../../api/case'; 
import router from "@/router";
import DesignImageDialog from '../../components/designImageDialog.vue';
import { preferProductMap } from '../../common/enum.js';
import _get from 'lodash/get';
import { useStore } from "vuex";
const $store = useStore();
const _id = _get( $store, 'state.factorySelect.id', '' );

const props = defineProps({
    info: {
        type: Object,
        default: {}
    },
    activeStep: Number
});

const emits = defineEmits(['pre', 'next']);

const time = ref('');
const totalPoints = ref(0); // 积分点数
const urgentPoints = ref(0); // 加急的积分点数
const price = ref(0); // 税前总价
const taxPrice = ref(0); // 增值税
const afterTaxPrice = ref(0); // 税后总价
const preferDetail = ref([]); // 设计偏好详情
const urgentPrice = ref(0); // 加急费用
const loading = ref( false );
const changeUnitLength = ref(0); // 设计费用计算的单位：perCase - 1. perJaw - 计算颌数量 perHole/perPiece - 计算颗的数量

watch(() => props.info, ( val ) => {
    const { activeCommodity = {}, tooths = [] } = val;

    // 交付时间
    if ( val.isUrgent ) {
        // time.value = `${activeCommodity.urgentDeliveryDay}${timeMap[activeCommodity.urgentDeliveryUnit]}`
        time.value = $timeUnit( $lang(), activeCommodity.urgentDeliveryUnit, activeCommodity.urgentDeliveryDay );
    } else {
        // time.value = `${activeCommodity.deliveryDay}${timeMap[activeCommodity.deliveryUnit]}`
        time.value = $timeUnit( $lang(), activeCommodity.deliveryUnit, activeCommodity.deliveryDay );
    }
    changeUnitLength.value = 0;
    // 根据计费单位 + 牙位选择的情况，计算计费数量
    if ( activeCommodity.chargeUnit === 'perCase' ) {
        // 案例计算：配置牙位：案例、颌、颗
        changeUnitLength.value = 1; 
    } else if ( activeCommodity.chargeUnit === 'perJaw' ) {
        // 颌面计算：配置牙位：颌、颗
        if (tooths.some(item => item === 'upperJaw') || tooths.some(item => item === 'lowerJaw')) {
            changeUnitLength.value = tooths.length; 
        } else {
            // 计算对应牙位在哪些颌面上，计算出有多少个颌
            const { inUpperJaw, inLowerJaw } = toothInUpOrLowerJaw(tooths);
            if ( inUpperJaw ) {
                changeUnitLength.value = changeUnitLength.value + 1;
            }
            if ( inLowerJaw ) {
                changeUnitLength.value = changeUnitLength.value + 1;
            }
        }
    } else if ( activeCommodity.chargeUnit === 'perHole' || activeCommodity.chargeUnit === 'perPiece' ) {
        // 按颗/孔计算：配置牙位：颗
        changeUnitLength.value = tooths.length; 
    }

    // 价格：（每颗价格 + 加急价格）*数量
    const designPrice = new BigNumber(activeCommodity.price);
    const perPrice = val.isUrgent ?  designPrice.plus( activeCommodity.urgentPrice ) : designPrice;
    // 有增值税的需要加上总的增值税
    // 增值税额=（总的设计费用+总的加急费用）x 当地税率
    // 总计费用=设计费用+加急费用+增值税额
    price.value = perPrice.multipliedBy( changeUnitLength.value ).toString();
    afterTaxPrice.value = price.value;
    urgentPrice.value = val.isUrgent ? new BigNumber(activeCommodity.urgentPrice).multipliedBy( changeUnitLength.value ).toString() : 0;
    
    // 积分价格
    const perPoint = val.isUrgent ? (activeCommodity.points + activeCommodity.urgentPoints) : activeCommodity.points;
    totalPoints.value = perPoint * changeUnitLength.value;
    urgentPoints.value = val.isUrgent ? activeCommodity.urgentPoints * changeUnitLength.value : 0;
    if ( val.taxRate ) {
        const taxRate = perPrice.multipliedBy( changeUnitLength.value ).multipliedBy(val.taxRate).multipliedBy(0.01);
        taxPrice.value = taxRate.toString();
        afterTaxPrice.value = perPrice.multipliedBy( changeUnitLength.value ).plus(taxRate).toString();
    }
    // 设计偏好的展示信息处理
    if ( val.preferenceValue ) {
        preferDetail.value = [];
        const configMap = {};
        (val.preferenceConfig?.preferences || []).forEach(item => {
            configMap[item.preCode] = item;
        });
        Object.keys( val.preferenceValue ).forEach(tooth => {
            const content = val.preferenceValue[tooth];
            // 后台配置表单的数据 + extra 固定数据
            const { preferences = [], extra } = content;
            const arr = preferences.map(item => {
                let preValue = '';
                const configInfo = configMap[item.preCode];
                if (configInfo.preType === 'option') {
                    preValue = configInfo.preOptions.find(i => i.optionCode === item.preValue)?.optionValue;
                } else if (configInfo.preType === 'number'){
                    preValue = item.preValue;
                }
                return {
                    ...item,
                    preValue,
                    preName: configMap[item.preCode].preName,
                    preUnit: configMap[item.preCode].preUnit,
                    paramApp: configMap[item.preCode].paramApp,                    
                }
            });
            
            if ( preferences.length || extra ) {
                preferDetail.value.push({
                    // tooth: toothNameMap[tooth] || tooth,
                    tooth: tooth,
                    list: arr,
                    extra
                });
            }
        });
    }
}, { deep: true });

const onNext = () => {
    const afterprice = new BigNumber(afterTaxPrice.value).toFixed(0);

    const preferenceValue = props.info.preferenceValue;
    const arr = [];  
    if ( preferenceValue && Object.keys(preferenceValue).length ) {
        const configMap = {};
        (props.info?.preferenceConfig?.preferences || []).forEach(item => {
            configMap[item.preCode] = item;
        });       
        // 处理设计偏好的设置
        Object.keys(preferenceValue).forEach(tooth => {
            const obj = preferenceValue[tooth];
            let systemID = '';
            if (obj.extra) {
                systemID = JSON.parse(obj.extra)?.systemID
            }
            arr.push({
                tooth: tooth, // 牙号
                isSave: props.info.ckboxValue === tooth ? 1 : 0,
                content: JSON.stringify(obj),
                systemID
            });
        });
    }

    const params = {
        ...props.info,
        preferences: arr,
        lang: $lang(),
        factoryID: _id,
        price: Number(price.value), 
        urgentPrice: Number(urgentPrice.value),
        afterTaxPrice: Number(afterprice),
        points: totalPoints.value,
        urgentPoints: urgentPoints.value
    };
    loading.value = true;
    Api.saveDesignOrder( params ).then(( res ) => {
        loading.value = false;
        if ( res && res.status === 'success' ) {
            sessionStorage.setItem('detanlDesignChooseGood', '');
            XlMessage({
                type: 'success',
                message: $t('design.case.createCaseSuccess') || '创建订单成功'
            });
            const tabName = props.info?.activeCommodity?.aiProduct ? 'inDesign' : ''
            router.push({
                name: 'designOrder', params: { tabName: tabName }
            });
        }
    }).catch(() => {
        loading.value = false;
    });
};

const onPre = () => {
    emits('pre');
};

const visible = ref(false);
const currentType = ref('');
const onShowImage = () => {
    visible.value = true;
    currentType.value = preferProductMap[props.info.productConfig]?.imageType
};

</script>

<style lang="scss" scoped>
$case-border-color: #E0E4EA;
.case-preview-wrap {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    font-family: 'Alibaba PuHuiTi 2.0';
    padding-top: 24px;
    box-sizing: border-box;
    .content {
        flex: 1;
        box-sizing: border-box;
        margin: 0px 0px 19px 16px;
        height: 100%;
        overflow-y: auto;
        .content-center {
            padding-right: 16px;
            :deep(.requirement-main){
                margin-top: 12px !important;
                margin-bottom: 16px !important;
            }
        }

        .card {
            // border: 1px solid #E0E4EA;
            // background: #fff;
            border-radius: 6px;
            width: 100%;
            // height: 178px;
            min-height: 136px;
            box-sizing: border-box;
            padding: 16px;
            margin-bottom: 24px;
            background: #F7F8FA;

            .head {
                height: 32px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;
                img {
                    width: 48px;
                    height: 32px;
                    border-radius: 4px;
                    background-size: contain;
                    background-color: #FFFFFF;
                }

                .name {
                    margin-left: 10px;
                    font-weight: 500;
                    color: #42526E;
                    font-size: 16px;
                }
                .soon {
                    height: 20px;
                    line-height: 20px;
                    padding: 0px 15px;
                    border-radius: 10px 0px 10px 10px;
                    background: #E64C4C;
                    color: #fff;
                    margin-left: 4px;
                    font-size: 12px;
                    display: inline-block;
                }
                .price {
                    font-weight: 500;
                    font-size: 18px;
                    color: #FF6914;
                }
            }
            .hr {
                height: 1px;
                width: 100%;
                background: #E0E4EA;
            }
            .detail {
                margin-top: 14px;
                display: flex;
                justify-content: space-between;
                font-size: 14px;

                .key {
                    color: #737E99;
                    line-height: 22px;
                    margin-bottom: 4px;
                }
                .value {
                    color: #2C364E;
                    line-height: 20px;
                    max-width: 250px;
                }
                .icon-zhuyi {
                    padding-right: 4px;
                }
            }
            // .time {
            //     font-size: 14px;
            //     line-height: 22px;
            //     color: #737E99;
            //     display: flex;
            //     align-items: center;
            //     .iconfont {
            //         color: #A5ACBE;
            //         margin-right: 7px;
            //     }
            //     .num {
            //         padding-left: 4px;
            //         color: #42526E;
            //     }
            // }
        }

        .desc-tlt {
            padding-top: 8px;
            margin-bottom: 12px;
        }
        .design-description{
            margin-top: 16px;
        }
        .desc-list, 
        .file-list {
            .item {
                margin-bottom: 16px;
                font-size: 14px;
                line-height: 22px;
                min-height: 68px;
                .title {
                    color: #737E99;
                    margin-bottom: 4px;
                }
                .text {
                    color: #2C364E;
                    word-wrap: break-word;
                }
                .design-content {
                    // white-space: pre;
                    word-wrap: break-word;
                }
            }
        }
        .file-list {
            display: flex;
            .item {
                flex: 1;
                overflow: hidden;
            }
            .item-first {
                margin-right: 16px;
                // max-width: 376px;
                
            }
            .text {
                .icon-file {
                    color: #737E99;
                    margin-right: 8px;
                    vertical-align: middle;
                    background: url('../../assets/image/report.svg');
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                }
            }
        }
        .block-item {
            background: #F7F8FA;
            box-sizing: border-box;
            padding: 12px 16px;
            border-radius: 6px;
        }
        .prefer-desc-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .perfer-image-tlt {
                font-size: 14px;
                font-weight: 500;
                font-family: $font-family65;
                color: #5587FF;
                cursor: pointer;
            }
        } 
    }

    .footer {
        margin-right: 16px;
        box-sizing: border-box;
        height: 68px;
        display: flex;
        border-top: 1px solid $case-border-color;
        align-items: center;
        flex-direction: row-reverse;

        .pre-btn {
            margin-right: 16px;
        }
    }
}
</style>